const BYTE_TO_HEX: string[] = [];
for (let i = 0; i < 256; i++) {
    BYTE_TO_HEX.push((i + 0x100).toString(16).slice(1));
}

/**
 * Generates an RFC 4122 v4 UUID.
 *
 * Prefers crypto.randomUUID(), but that is a secure-context-only API: on a plain-http
 * origin (e.g. reaching the webpack dev server by LAN IP instead of localhost) window.crypto
 * exists while window.crypto.randomUUID is undefined, and calling it throws a TypeError.
 * crypto.getRandomValues() carries no such restriction, so assemble the v4 by hand there.
 *
 * This mirrors the fallback the `uuid` package provided before BA-19612 dropped it.
 */
export function uuid(): string {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }

    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);

    // Version 4 in the high nibble of byte 6, RFC 4122 variant in the top bits of byte 8.
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, byte => BYTE_TO_HEX[byte]);
    return [
        hex.slice(0, 4).join(""),
        hex.slice(4, 6).join(""),
        hex.slice(6, 8).join(""),
        hex.slice(8, 10).join(""),
        hex.slice(10, 16).join("")
    ].join("-");
}
